angular.module('picmonicng').controller('EditProfileController', [
  '$scope',
  '$filter',
  '$timeout',
  'UserService',
  'Upload',
  'Schools',
  'MarketOptionsConfig',
  'MonthOptionsConfig',
  'PendoService',
  'SalesforceChatService',
  'PermissionsService',
  '$state',
  'toaster',
  function (
    $scope,
    $filter,
    $timeout,
    UserService,
    Upload,
    Schools,
    MarketOptionsConfig,
    MonthOptionsConfig,
    PendoService,
    SalesforceChatService,
    PermissionsService,
    $state,
    toaster
  ) {
    $scope.updated_success = false;
    $scope.loading = true;
    $scope.misc = {};
    $scope.MarketOptionsConfig = MarketOptionsConfig;
    $scope.months = MonthOptionsConfig.months;
    $scope.user = {};
    $scope.PermissionsService = PermissionsService;

    $scope.range = function (min, max, step) {
      step = step || 1;
      var input = [];
      for (var i = min; i <= max; i += step) input.push(i);
      return input;
    };

    angular.copy(UserService.user, $scope.user);

    $scope.userProfileCompleted = $filter('profileCompletePercentage')($scope.user);

    $scope.$on('$viewContentLoaded', function () {
      angular.forEach($scope.updateProfileForm.$error.required, function (field) {
        field.$setTouched();
      });
      $scope.$emit('endInteraction');
    });

    $scope.loading = false;

    $scope.updateProfile = function () {
      if (!$scope.loading) {
        $scope.loading = true;
        $scope.updated_success = false;
        var refresh = false;
        if (UserService.user.lead != $scope.user.lead) {
          refresh = true;
        }
        angular.merge(UserService.user, $scope.user);

        UserService.user.$update().then(
          function () {
            PendoService.setUserInfo(UserService.user);
            SalesforceChatService.setUserInfo(UserService.user);

            $scope.updated_success = true;
            $scope.loading = false;
            angular.copy(UserService.user, $scope.user);
            $timeout(function () {
              $scope.updated_success = false;
              if (refresh) {
                window.location = '/home';
              } else {
                $state.go('app.apphome');
              }
            }, 500);
          },
          function (error) {
            $scope.updated_success = false;
            $scope.loading = false;

            if (error?.data?.message) {
              toaster.error('Error: ' + error.data.message);
            }
          }
        );
      }
    };
  },
]);
